import React, { Component } from 'react';
import '../App.css';
import Card from './Card';
import results from '../data.json';

class Grid extends Component {
  render() {
    return (
      <div className="container grid">
        <div className="row">
            <Card isSmallCard data={results[0]} />
            <Card isSmallCard data={results[1]} />
            <Card isSmallCard data={results[2]} />
        </div>
        <div className="row">
          <Card isSmallCard data={results[3]} />
          <Card isSmallCard data={results[4]} />
          <Card isSmallCard data={results[5]} />
        </div>
        <div className="row">
          <Card isSmallCard data={results[6]} />
          <Card isSmallCard data={results[7]} />
          <Card isSmallCard data={results[8]} />
        </div>
        <div className="row">
          <Card isSmallCard data={results[9]} />
          <Card isSmallCard data={results[10]} />
        </div>
      </div>
    );
  }
}


export default Grid;